export type Styles = {
  [key: string]: {
    size: string,
    fontWeight: string,
    letterSpacing?: string,
    lineHeight?: string,
  }
}

export const Styles: { [key: string]: Styles } = {
  andréeputman: {
    titleLarge: { size: '19px', fontWeight: '600' },
    titleMedium: { size: '15px', fontWeight: '600' },
    labelSmallBold: { size: '12px', fontWeight: '600' },

    headingXLarge: { size: '19px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingLarge: { size: '17px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingMedium: { size: '15px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingSmall: { size: '15px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingXSmall: { size: '12px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    labelSmall: { size: '11px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },

    textXLarge: { size: '17px', fontWeight: '500' },
    textLarge: { size: '15px', fontWeight: '300', lineHeight: '15px' },
    textMedium: { size: '13px', fontWeight: '300', lineHeight: '15px' },
    textSmall: { size: '12px', fontWeight: '300', lineHeight: '15px' },
    textXSmall: { size: '11px', fontWeight: '300', lineHeight: '15px' },

    bodyXLarge: { size: '15px', fontWeight: '300', lineHeight: '20px' },
    bodyLarge: { size: '15px', fontWeight: '300', lineHeight: '20px' },
    bodyMedium: { size: '13px', fontWeight: '300', lineHeight: '20px' },
    bodySmall: { size: '13px', fontWeight: '300', lineHeight: '20px' },
    bodyXSmall: { size: '11px', fontWeight: '300', lineHeight: '20px' },
  },
  delcourtedition: {
    titleLarge: { size: '17px', fontWeight: '600' },
    titleMedium: { size: '13px', fontWeight: '600' },
    labelSmallBold: { size: '11px', fontWeight: '600' },

    headingXLarge: { size: '17px', fontWeight: '500', lineHeight: '20px', letterSpacing: '0.06em' },
    headingLarge: { size: '15px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingMedium: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingSmall: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingXSmall: { size: '11px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    labelSmall: { size: '10px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },

    textXLarge: { size: '15px', fontWeight: '500' },
    textLarge: { size: '13px', fontWeight: '300', lineHeight: '15px' },
    textMedium: { size: '12px', fontWeight: '300', lineHeight: '15px' },
    textSmall: { size: '11px', fontWeight: '300', lineHeight: '15px' },
    textXSmall: { size: '10px', fontWeight: '300', lineHeight: '15px' },

    bodyXLarge: { size: '13px', fontWeight: '300', lineHeight: '20px' },
    bodyLarge: { size: '14px', fontWeight: '300', lineHeight: '20px' },
    bodyMedium: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodySmall: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodyXSmall: { size: '10px', fontWeight: '300', lineHeight: '20px' },
  },
  collectionparticulière: {
    titleLarge: { size: '17px', fontWeight: '600' },
    titleMedium: { size: '13px', fontWeight: '600' },
    labelSmallBold: { size: '11px', fontWeight: '600' },

    headingXLarge: { size: '17px', fontWeight: '500', lineHeight: '20px', letterSpacing: '0.06em' },
    headingLarge: { size: '15px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingMedium: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingSmall: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingXSmall: { size: '11px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    labelSmall: { size: '10px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },

    textXLarge: { size: '15px', fontWeight: '500' },
    textLarge: { size: '13px', fontWeight: '300', lineHeight: '15px' },
    textMedium: { size: '12px', fontWeight: '300', lineHeight: '15px' },
    textSmall: { size: '11px', fontWeight: '300', lineHeight: '15px' },
    textXSmall: { size: '10px', fontWeight: '300', lineHeight: '15px' },

    bodyXLarge: { size: '13px', fontWeight: '300', lineHeight: '20px' },
    bodyLarge: { size: '14px', fontWeight: '300', lineHeight: '20px' },
    bodyMedium: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodySmall: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodyXSmall: { size: '10px', fontWeight: '300', lineHeight: '20px' },
  },
  christianlouboutin: {
    titleLarge: { size: '17px', fontWeight: '600' },
    titleMedium: { size: '13px', fontWeight: '600' },
    labelSmallBold: { size: '11px', fontWeight: '600' },

    headingXLarge: { size: '17px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingLarge: { size: '15px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingMedium: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingSmall: { size: '13px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    headingXSmall: { size: '11px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },
    labelSmall: { size: '10px', fontWeight: '500', lineHeight: '14px', letterSpacing: '0.06em' },

    textXLarge: { size: '15px', fontWeight: '500' },
    textLarge: { size: '13px', fontWeight: '300', lineHeight: '15px' },
    textMedium: { size: '12px', fontWeight: '300', lineHeight: '15px' },
    textSmall: { size: '11px', fontWeight: '300', lineHeight: '15px' },
    textXSmall: { size: '10px', fontWeight: '300', lineHeight: '15px' },

    bodyXLarge: { size: '13px', fontWeight: '300', lineHeight: '20px' },
    bodyLarge: { size: '14px', fontWeight: '300', lineHeight: '20px' },
    bodyMedium: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodySmall: { size: '11px', fontWeight: '300', lineHeight: '20px' },
    bodyXSmall: { size: '10px', fontWeight: '300', lineHeight: '20px' },
  },
}

export function overrideTextStyles(styles: Styles) {
  Object.entries(styles).forEach(([key, { size, fontWeight, letterSpacing, lineHeight }]) => {
    if (size) document.documentElement.style.setProperty(`--${key}-size`, size);
    if (fontWeight) document.documentElement.style.setProperty(`--${key}-weight`, fontWeight);
    if (letterSpacing != null) document.documentElement.style.setProperty(`--${key}-letterSpacing`, letterSpacing);
    if (lineHeight != null) document.documentElement.style.setProperty(`--${key}-lineHeight`, lineHeight);
  });
}
